import { toast } from "@jti/core-components/components/Toaster";
import { isApiErrorWithErrorCode, translateBackendErrorCode } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import type { VideoPlayerProps } from "@jti/ui/components/VideoPlayer";
import { VideoPlayer } from "@jti/ui/components/VideoPlayer";
import { useTranslations } from "@jti/ui/providers/useTranslations";

export type LoyaltyVideoPlayerProps = Omit<VideoPlayerProps, "watchTimeTrigger"> & {
  watchTimeTrigger?: Omit<NonNullable<VideoPlayerProps["watchTimeTrigger"]>, "onWatchTimeReached">;
  percentageToWatch?: number;
  videoId: string;
  isWatchTimeTracked?: boolean;
  onWatchTimeReached?: () => void;
  pointsGranted?: number;
};
export const LoyaltyVideoPlayer = (props: LoyaltyVideoPlayerProps) => {
  const { __, dictionary } = useTranslations();
  const { percentageToWatch, videoId, isWatchTimeTracked, onWatchTimeReached, pointsGranted } = props;

  const handleWatchTimeReached = async () => {
    const user = getUser();
    if (!user.uuid || isWatchTimeTracked === false) return;
    try {
      await LoyaltyApi.init().watchVideoAction(user.uuid, videoId);
      toast.success(__("loyalty.videoPoints.trigger.success", [pointsGranted ?? 0]));
      if (onWatchTimeReached) {
        onWatchTimeReached();
      }
    } catch (e) {
      const error = translateBackendErrorCode(
        isApiErrorWithErrorCode(e) ? e.error_code : undefined,
        __("loyalty.videoPoints.trigger.error"),
        dictionary
      );
      toast.error(error);
    }
  };

  return (
    <VideoPlayer
      {...props}
      enforceCustomControls={true}
      watchTimeTrigger={{
        percentageToWatch,
        onWatchTimeReached: () => {
          // passed as a function because onWatchTimeReached expects a () => void type, but handleWatchTimeReached is () => Promise
          handleWatchTimeReached();
        },
      }}
    />
  );
};
